var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require("./google-colored.png"),"width":"24px","height":"24px"}})}
var staticRenderFns = []

export { render, staticRenderFns }